// Domain enums. Keep in sync with docs/02-schema.md and api/src/db/schema.ts.

export const Role = {
  RESIDENT: 'RESIDENT',
  SECURITY: 'SECURITY',
  STAFF: 'STAFF',
} as const;
export type Role = (typeof Role)[keyof typeof Role];

export const UserStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const AuthProvider = {
  GOOGLE: 'GOOGLE',
  PASSWORD: 'PASSWORD',
  CLERK: 'CLERK',
} as const;
export type AuthProvider = (typeof AuthProvider)[keyof typeof AuthProvider];

export const AdminScope = {
  CLUSTER: 'CLUSTER',
  DEVELOPER: 'DEVELOPER',
  PLATFORM: 'PLATFORM',
} as const;
export type AdminScope = (typeof AdminScope)[keyof typeof AdminScope];

export const Platform = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  WEB: 'WEB',
} as const;
export type Platform = (typeof Platform)[keyof typeof Platform];

export const NotificationCategory = {
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  PAYMENT: 'PAYMENT',
  BOOKING: 'BOOKING',
  COMPLAINT: 'COMPLAINT',
  VISITOR: 'VISITOR',
  PACKAGE: 'PACKAGE',
  EMERGENCY: 'EMERGENCY',
  SYSTEM: 'SYSTEM',
} as const;
export type NotificationCategory =
  (typeof NotificationCategory)[keyof typeof NotificationCategory];

// Permission flags carried in JWT for STAFF/SECURITY users.
// Resident permission set is empty.
export const StaffPermissions = [
  'can_manage_staff',
  'can_manage_units',
  'can_manage_residents',
  'can_manage_invite_codes',
  'can_post_announcements',
  'can_manage_facilities',
  'can_approve_bookings',
  'can_manage_payments',
  'can_manage_complaints',
  'can_view_emergency',
] as const;
export type StaffPermission = (typeof StaffPermissions)[number];

export const SecurityPermissions = [
  'can_scan_visitors',
  'can_log_packages',
  'can_respond_emergency',
] as const;
export type SecurityPermission = (typeof SecurityPermissions)[number];

export type AnyPermission = StaffPermission | SecurityPermission;
